import { Route, NavigationGuardNext } from "vue-router";
import { getModule } from "vuex-module-decorators";
import TitleListState from "@/modules/title-list";
import { VersionGroupModule } from "@/modules/versiongroup";
import { REPModule } from "@/modules/rep";
import CategoryManagerState from "@/modules/category-manager";
import { CurriculumType } from "@/util/enum";

export const REPResolver = async (to: Route, from: Route, next: NavigationGuardNext) => {
	const titleListModule = getModule(TitleListState);
	const categoryModule = getModule(CategoryManagerState);
	const repModule = REPModule;
	const actions: Promise<void>[] = [];
	if (to.params.id) {
		actions.push(titleListModule.fetchContentDetails(to.params.id));
		actions.push(repModule.fetchDefaultMediaSlot(to.params.id));
	}
	if (!categoryModule.categories.length) {
		actions.push(categoryModule.fetchCategories());
	}
	await Promise.all(actions);
	const { getEditedContentDetails, editeContentSelectedChapterId, editedContentId } = titleListModule;
	const versionGroupId =
		getEditedContentDetails.curriculumType === CurriculumType.GrapeSEED
			? VersionGroupModule.selectedGsVersion
			: VersionGroupModule.selectedLsVersion;
	const vcsLevelId = getEditedContentDetails.vcsLevelId;
	const contentId =
		editeContentSelectedChapterId !== "none" && editeContentSelectedChapterId !== "all"
			? editeContentSelectedChapterId
			: editedContentId;
	REPModule.setContentVersionGroupId({ versionGroupId, contentId, vcsLevelId });
	REPModule.setREPList([]);
	next();
};
